export const AffiliationStatus = Object.freeze({
    Pending: 0,
    Approved: 1,
    PartiallyApproved: 2,
    Denied: 3,
    Removed: 4,
    Processing: 5
});